import {basicSetup, EditorView} from "codemirror"
import {javascript} from "@codemirror/lang-javascript"
import {placeholder} from "@codemirror/view";

function copyEditorToTextArea(view: EditorView, textarea: HTMLTextAreaElement) {
	textarea.value = view.state.doc.toString();
}

function toggleTextArea(textarea: HTMLTextAreaElement, visible: boolean) {
	textarea.style.display = visible ? '' : "none";
}

function editorFromTextArea(textarea: HTMLTextAreaElement, extensions: any[]) {
	let initialValue = textarea.value;
	/*
		const minRows = textarea.rows;
		if (Number.isFinite(minRows)) {
			const rows = Math.max(1, minRows);
			if (initialValue.trim().length == 0) {
				initialValue = "\n".repeat(rows);
			}
		}
	*/

	let view = new EditorView({doc: initialValue, extensions})

	textarea.parentNode!!.insertBefore(view.dom, textarea)
	toggleTextArea(textarea, false);
	if (textarea.form) {
		textarea.form.addEventListener("submit", () => copyEditorToTextArea(view, textarea));
	}

	return view
}

export class JavascriptEditor {
	constructor(textarea: string | HTMLTextAreaElement) {
		if (typeof textarea === 'string') {
			document.querySelectorAll<HTMLTextAreaElement>(textarea).forEach(node => {
				this.configureEditor(node);
			})

		} else {
			this.configureEditor(textarea)
		}
	}

	private configureEditor(textarea: HTMLTextAreaElement) {
		editorFromTextArea(textarea, [
			placeholder(textarea.placeholder),
			basicSetup,
			javascript(),
		]);
	}
}
